/** @format */

import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Container } from "react-bootstrap";

import { singleService } from "../../../Features/HomeApi/HomeSlice";
import PageHeadings from "../PageHeadings";
import Grammer from "../../DashboardView/Container/GrammarPages/Grammer";
import Loader from "../Loader/Loader";
import SEO from "../Seo/Seo";

const ModuleGrammar = () => {
  const dispatch = useDispatch();

  const selectedService = useSelector(
    (state) => state.home.selectedSingleService,
    shallowEqual,
  );
  const seoData = selectedService?.seo_data;
  const isLoading = useSelector((state) => state.home.homeModuleLoading);

  // Fetch service (id: 2)
  useEffect(() => {
    dispatch(singleService({ id: 2 }));
  }, [dispatch]);

  return (
    <>
      {seoData && (
        <SEO
          title={seoData.meta_title}
          description={seoData.meta_description}
          keywords={seoData.meta_keywords?.join(", ")}
          path={seoData.canonical_url}
        />
      )}

      {!isLoading ?
        <>
          <PageHeadings item={selectedService} hasIcon="true" />
          <Container>
            <div className="home__dictionary">
              <Grammer />
            </div>
          </Container>
        </>
      : <div className="loading__mode bigLoading">
          <Loader />
        </div>
      }
    </>
  );
};

export default ModuleGrammar;
